import type { PropsWithChildren } from 'react';

import { BrazeBanner } from 'Components/BrazeBanner/BrazeBanner';
import { BRAZE_BANNERS_ID } from 'Components/BrazeBanner/BrazeBanner.helpers';
import { VehicleInfoContextProvider } from 'Context/VehicleInfoContext';

import { BuyItNow } from './BuyItNow/BuyItNow';
import { NotYetForSale } from './NotYetForSale/NotYetForSale';
import { PriceAndSaleInfo } from './PriceAndSaleInfo/PriceAndSaleInfo';
import { SaleActive } from './SaleActive/SaleActive';
import { Sold } from './Sold/Sold';
import { UnderOffer } from './UnderOffer/UnderOffer';
import type { UseBiddingViewName } from './useBiddingViewName';
import { useBiddingViewName } from './useBiddingViewName';

import styles from './BiddingSection.module.scss';

const BiddingSectionLayout: React.FC<PropsWithChildren> = ({ children }) => {
	return <div className={styles.wrapper}>{children}</div>;
};

const ConditionalBiddingView: React.FC<{ viewName: NonNullable<UseBiddingViewName> }> = ({ viewName }) => {
	switch (viewName) {
		case 'saleActive':
			return <SaleActive />;
		case 'saleOverProcessing':
			return <PriceAndSaleInfo badgeVariant="saleOverProcessing" />;
		case 'underOffer':
			return <UnderOffer />;
		case 'buyItNow':
			return <BuyItNow />;
		case 'sold':
			return <Sold />;
		case 'notYetForSale':
			return <NotYetForSale />;
		case 'unsold':
			return <PriceAndSaleInfo badgeVariant="unsold" />;
		default:
			return null;
	}
};

export const BiddingSection: React.FC = () => {
	const biddingViewName = useBiddingViewName();

	if (!biddingViewName) {
		return null;
	}

	return (
		<VehicleInfoContextProvider>
			<BiddingSectionLayout>
				<ConditionalBiddingView viewName={biddingViewName} />
				<BrazeBanner bannerId={BRAZE_BANNERS_ID.BID_FOOTER} className={styles.brazeBanner} />
			</BiddingSectionLayout>
		</VehicleInfoContextProvider>
	);
};
